export default __webpack_public_path__ + "static/media/furgonetka-sm.823122a9.svg";